<template>
  <article class="kanban-card" data-component="Kanban/KanbanCard" @click="$emit('card-click', visit)">
    <div class="kanban-card__header">
      <span class="kanban-card__nsil">{{ visit.nsil }}</span>
      <span class="kanban-card__type">{{ visit.propertyType }}</span>
    </div>

    <div class="kanban-card__address">
      <i class="fas fa-map-marker-alt kanban-card__icon"></i>
      <div>
        <span class="kanban-card__city">{{ visit.address.zipCode }} {{ visit.address.city }}</span>
        <span class="kanban-card__street">{{ visit.address.street }}</span>
      </div>
    </div>

    <div class="kanban-card__mandant" v-if="visit.mandant">
      <i class="fas fa-building kanban-card__icon"></i>
      <span>{{ visit.mandant }}</span>
    </div>

    <div class="kanban-card__manager" v-if="visit.technicalManager">
      <i class="fas fa-user kanban-card__icon"></i>
      <span>{{ visit.technicalManager }}</span>
    </div>
    <div class="kanban-card__manager kanban-card__manager--empty" v-else>
      <i class="fas fa-user-slash kanban-card__icon"></i>
      <span>Non attribué</span>
    </div>

    <div class="kanban-card__footer">
      <div class="kanban-card__date" v-if="visit.scheduledDate">
        <i class="fas fa-calendar-alt kanban-card__icon"></i>
        <span>{{ formatDate(visit.scheduledDate) }}</span>
      </div>
      <div class="kanban-card__date kanban-card__date--empty" v-else>
        <i class="fas fa-calendar-times kanban-card__icon"></i>
        <span>Non planifiée</span>
      </div>

      <span v-if="visit.occupancy" class="kanban-card__occupancy-badge"
        :class="`kanban-card__occupancy-badge--${visit.occupancy.toLowerCase()}`">
        {{ visit.occupancy }}
      </span>
    </div>
  </article>
</template>

<script>
export default {
  name: 'KanbanCard',
  props: {
    visit: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
    }
  }
}
</script>

<style lang="scss" scoped>
@use './KanbanCard.scss';
</style>
